module.exports = __webpack_public_path__ + "img/Mascot_voyage.b0674a97.png";